import { Modal } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";

const AddOrUpdateCategoryLoadingPopup = props => {

    return (
        <Modal backdrop="static" show>
            <Modal.Body className='text-center'>
                <div className='my-5'>
                    <ClipLoader className='mb-2' color='#075978' />
                    <h5>{props.content}</h5>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddOrUpdateCategoryLoadingPopup;